import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../pages/Home.vue'
Vue.use(VueRouter)

// 3. 配置路由规则数组
const routes = [
	{
	        path: '/',        // 根路径
	        component: home   // 直接使用首页组件
	    },
	// { 
	//         path: '/',
	//      redirect:'/index'
	//     },
	// {
	// 	path: '/index',
	// 	component: home
	// },
]
// 4. 实例化VueRouter
const router =  new VueRouter({
	 mode: 'history', 
    routes
})
router.afterEach(() => {window.scrollTo(0,0);
})
// 5. 导出路由实例对象router
export default router


// WEBPACK FOOTER //
// ./src/router/index.js